import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App.jsx';
import './index.css';

/** Producción: PWA (vite-plugin-pwa). En desarrollo no se registra SW (ver vite.config + script inyectado). */
if (import.meta.env.PROD) {
    registerSW({ immediate: true });
}

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
